import React, { PureComponent, Fragment } from 'react';

import { Grid, Cell } from 'formlabs-web-components/Grid';
import { Spinner } from 'formlabs-web-components/Navigation';
import { Input, TextArea } from 'formlabs-web-components/Form';
import { Header } from 'formlabs-web-components/Type';

import Cookies from 'js-cookie';
import { withTranslation } from 'react-i18next';

import { analytics } from '../../utils';

import './ContactSales.module.css';
import CompanySizeSelect from './selects/CompanySizeSelect';
import CountrySelect from './selects/CountrySelect';
import StateSelect from './selects/StateSelect';
import IndustrySelect from './selects/IndustrySelect';
import OccupationSelect from './selects/OccupationSelect';
import identifyIntegrations from './identifyIntegrations';
import TextPlugin from '../cms/TextPlugin';

class ContactSalesForm extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      submitting: false,
      submitted: false,
      error: false,
      country: null
    };
    this.onClose = this.props.onClose;
  }

  onFormSubmit(e) {
    e.preventDefault();
    this.setState({ submitting: true, error: false });

    const csrftoken = Cookies.get('csrftoken');
    const form = e.target;
    let form_data = new FormData(form);

    analytics.identify(
      form_data.get('tfa_5'),
      {
        email: form_data.get('tfa_5'),
        firstName: form_data.get('tfa_2'),
        lastName: form_data.get('tfa_3')
      },
      identifyIntegrations
    );
    analytics.track(
      'Contact Sales Form Submitted',
      {
        category: 'Segment',
        email: form_data.get('tfa_5')
      },
      {
        integrations: {
          Marketo: false,
          'Marketo V2': false
        }
      }
    );
    fetch(form.action, {
      method: 'POST',
      body: form_data,
      headers: {
        'X-CSRFToken': csrftoken
      }
    })
      .then(res => res.json())
      .then(() => {
        this.setState({
          submitting: true
        });
      })
      .then(() => {
        this.setState({ submitting: false, submitted: true });
        setTimeout(
          function() {
            this.onClose();
          }.bind(this),
          1000
        );
      })
      .catch(error => {
        this.setState({
          submitted: false,
          submitting: false,
          error: true
        });
      });
  }

  onSelectCountry = e => {
    this.setState({ country: e.target.value });
  };

  render() {
    const { t, path, buttonText, title, body, boldTitle } = this.props;
    const { submitting, submitted, error, country } = this.state;
    if (submitted) {
      return (
        <Grid direction="x" gutters="margin">
          <Cell mediumSize={24} secondaryAlignment="align-self-middle">
            {t('Thanks for your submission.')}
          </Cell>
        </Grid>
      );
    }
    const isUs = country === 'United States';
    return (
      <Fragment>
        <Grid direction="x" gutters="margin">
          <Cell mediumSize={24}>
            <Header level={4} displayAs={4} weight={boldTitle ? 700 : 400}>
              {title}
            </Header>
          </Cell>
          <Cell mediumSize={24}>
            <TextPlugin body={body}>{body}</TextPlugin>
          </Cell>
        </Grid>
        <form
          action="/form_proxy/"
          className="contact-sales-form ga-track"
          data-ga-action="Submit sales inquiry"
          id="tfa_0"
          method="POST"
          styleName="contact-form"
          onSubmit={this.onFormSubmit.bind(this)}
        >
          <Input
            id="Campaign_ID"
            name="tfa_29"
            type="hidden"
            value="701i0000000f64K"
          />
          <Input
            id="Referral URL"
            maxLength="255"
            name="tfa_30"
            type="hidden"
            value=""
          />
          <Input
            id="Current URL"
            maxLength="255"
            name="tfa_54"
            type="hidden"
            value={path}
          />
          <Input
            id="Language Preference"
            maxLength="255"
            name="tfa_35"
            type="hidden"
            value=""
          />
          <Input
            id="Referral ID"
            maxLength="255"
            name="tfa_36"
            type="hidden"
            value=""
          />
          <Input
            id="contact-sales-user-id"
            maxLength="255"
            name="tfa_37"
            type="hidden"
          />
          <Input id="_mkt_trk" name="_mkt_trk" type="hidden" />
          <Input id="_tfa_mkt_trk" name="tfa_39" type="hidden" />
          <Input id="acquisition_source_first" name="tfa_40" type="hidden" />
          <Input id="acquisition_source_last" name="tfa_41" type="hidden" />
          <Input id="gclid" name="tfa_42" type="hidden" />
          <Input id="utm_campaign_first" name="tfa_44" type="hidden" />
          <Input id="utm_campaign_latest" name="tfa_45" type="hidden" />
          <Input type="hidden" id="utm_pt_first" name="tfa_46" />
          <Input type="hidden" id="utm_pt_latest" name="tfa_47" />
          <Input type="hidden" id="utm_content_first" name="tfa_48" />
          <Input type="hidden" id="utm_content_latest" name="tfa_49" />
          <Input type="hidden" id="utm_term_first" name="tfa_50" />
          <Input type="hidden" id="utm_term_latest" name="tfa_51" />
          <Input type="hidden" id="utm_medium_first" name="tfa_52" />
          <Input type="hidden" id="utm_medium_latest" name="tfa_53" />

          <Grid direction="x" gutters="margin">
            <Cell mediumSize={12}>
              <label htmlFor="first_name">{t('First name')}</label>
              <Input
                id="first_name"
                maxLength="40"
                name="tfa_2"
                required
                size="20"
                type="text"
              />
            </Cell>
            <Cell mediumSize={12}>
              <label htmlFor="last_name">{t('Last name')}</label>
              <Input
                id="last_name"
                maxLength="80"
                name="tfa_3"
                required
                size="20"
                type="text"
              />
            </Cell>
          </Grid>
          <Grid direction="x" gutters="margin">
            <Cell mediumSize={6}>
              <label htmlFor="email">{t('Business email')}</label>
              <Input
                id="email"
                maxLength="80"
                name="tfa_5"
                required
                size="20"
                type="email"
              />
            </Cell>
            <Cell mediumSize={6}>
              <label htmlFor="phone">{t('Phone')}</label>
              <Input
                id="phone"
                maxLength="40"
                name="tfa_6"
                required
                size="20"
                type="text"
              />
            </Cell>
            <Cell mediumSize={6}>
              <label htmlFor="company">{t('Company')}</label>
              <Input
                id="company"
                maxLength="40"
                name="tfa_7"
                required
                size="45"
                type="text"
              />
            </Cell>
            <Cell mediumSize={6}>
              <label htmlFor="employees">{t('Company Size')}</label>
              <CompanySizeSelect
                id="employees"
                name="tfa_11"
                title={t('Company Size')}
                required
              />
            </Cell>
          </Grid>
          <Grid direction="x" gutters="margin">
            <Cell mediumSize={6}>
              <label htmlFor="00Ni000000ECfSo">{t('Occupation')}</label>
              <OccupationSelect
                id="00Ni000000ECfSo"
                name="tfa_33"
                title={t('How Would You Describe Yourself?')}
                required
              />
            </Cell>
            <Cell mediumSize={6}>
              <label htmlFor="country">{t('Country')}</label>
              <CountrySelect
                id="country"
                name="tfa_19"
                required
                withFavorites
                onChange={this.onSelectCountry}
              />
            </Cell>
            {isUs && (
              <Cell mediumSize={6}>
                <label htmlFor="state">{t('State')}</label>
                <StateSelect id="state" name="tfa_55" required />
              </Cell>
            )}
            <Cell mediumSize={isUs ? 6 : 12}>
              <label htmlFor="industry">{t('Industry')}</label>
              <IndustrySelect id="industry" name="tfa_20" required />
            </Cell>
          </Grid>
          <Grid direction="x" gutters="margin" primaryAlignment="align-center">
            <Cell mediumSize={24}>
              <label htmlFor="00Ni000000EDLyx">
                {t('How can we help you?')}
              </label>
              <TextArea
                id="00Ni000000EDLyx"
                name="tfa_28"
                rows="3"
                type="text"
                wrap="soft"
                required
              />
            </Cell>
          </Grid>
          <Grid direction="x" gutters="margin">
            <Cell backgrounmediumSize={24}>
              {!submitting && !submitted && (
                <input className="button" type="submit" value={buttonText} />
              )}
              {submitting && !submitted && (
                <span styleName="submitting">
                  <Spinner size={3} color="#0762c8" />
                </span>
              )}
              <Input
                id="tfa_dbFormId"
                name="tfa_dbFormId"
                type="hidden"
                value="340164"
              />
              <Input
                id="tfa_dbResponseId"
                name="tfa_dbResponseId"
                type="hidden"
                value=""
              />
              <Input
                id="tfa_dbControl"
                name="tfa_dbControl"
                type="hidden"
                value="b3d2132f1a899696a53af585df7dd656"
              />
              <Input
                id="tfa_dbVersionId"
                name="tfa_dbVersionId"
                type="hidden"
                value="5"
              />
              <Input
                id="tfa_switchedoff"
                name="tfa_switchedoff"
                type="hidden"
                value=""
              />
            </Cell>
            <Cell mediumSize={16} secondaryAlignment="align-self-middle">
              {error && !submitted && (
                <span styleName="error">
                  <small>
                    {t(
                      'There was an error submitting your request. Please try again!'
                    )}
                  </small>
                </span>
              )}
            </Cell>
          </Grid>
        </form>
      </Fragment>
    );
  }
}

export default withTranslation()(ContactSalesForm);
